import type {Suggestions} from '@github-ui/inline-autocomplete/types'
import {useQuery} from '@github-ui/react-query'
import {useMemo} from 'react'

import {useChatManager} from '../../utils/CopilotChatManagerContext'
import {RepositorySuggestion} from './RepositorySuggestion'

export interface RepositoriesQuery {
  category: 'repositories'
  nextCategory?: 'issues' | 'pulls' | 'discussions'
  filter: string
}

export function useRepositoriesSuggestions(query: RepositoriesQuery | null) {
  const {service} = useChatManager()

  const repositoriesQuery = useQuery({
    enabled: query !== null,
    queryKey: ['copilot-autocomplete-repositories', query?.filter],
    queryFn: () => service.fetchAutocompleteRepositories(query?.filter ?? ''),
  })

  return useMemo<Suggestions | null>(() => {
    if (!query) return null

    if (repositoriesQuery.isLoading) return 'loading'

    const isMultistep = query.nextCategory !== undefined
    return (
      repositoriesQuery.data?.map(repo => ({
        value: isMultistep ? null : repo.nameWithOwner,
        key: repo.nameWithOwner,
        render: props => <RepositorySuggestion repository={repo} isMultistep={isMultistep} {...props} />,
      })) ?? null
    )
  }, [repositoriesQuery.isLoading, repositoriesQuery.data, query])
}
